import { Card, Link, Text } from '@nimbus-ds/components';
import { EditIcon } from '@nimbus-ds/icons';
import { AddressingConfigurationRuleResponseDto } from '@tiendanube/common';
import { ErrorScreen, Stack } from 'commons/components';
import { trackingShippingOpenAddressingRule } from 'domains/Shipping/tracking';
import useTranslationShipping from 'domains/Shipping/useTranslationShipping';
import RulesList from './RulesList';
import RulesListBodyAndFooterSkeleton from './RulesListBodyAndFooterSkeleton';

interface RulesListBodyAndFooterProps {
  rules: AddressingConfigurationRuleResponseDto[];
  isError: boolean;
  handleEdit: () => void;
  fetchRules: () => void;
}

function RulesListBodyAndFooter({
  rules,
  isError,
  handleEdit,
  fetchRules,
}: Readonly<RulesListBodyAndFooterProps>) {
  const { Body, Footer } = Card;
  const t = useTranslationShipping('deliveryMethods.addressingConfigurationV2');

  return (
    <>
      <Body>
        {!isError && (
          <Stack column spacing="base" align="stretch">
            <Text fontSize="base" lineHeight="base" textAlign="left">
              {t('info.description')}
            </Text>
            <RulesList rules={rules} />
          </Stack>
        )}
        {isError && (
          <ErrorScreen
            description={t('info.error.description')}
            onRetry={fetchRules}
          />
        )}
      </Body>
      {!isError && (
        <Footer>
          <Link
            onClick={() => {
              handleEdit();
              trackingShippingOpenAddressingRule(rules);
            }}
            appearance="primary"
            textDecoration="none"
          >
            <EditIcon />
            {t('info.edit')}
          </Link>
        </Footer>
      )}
    </>
  );
}

RulesListBodyAndFooter.Skeleton = RulesListBodyAndFooterSkeleton;
export default RulesListBodyAndFooter;
